// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* styles.css */

.headerStyle {
  width: 100%;
  height: 30%;
  background: #ffffff;
  border: 1px solid #D9D9D9;
  opacity: 1;
}

.searchStyle {
  text-align: left;
  font: normal normal normal 16px/24px;
  letter-spacing: 0px;
  color: #8C8C8C;
  opacity: 1;
  border-radius: 2px;
  margin-left: 5%;
}

.filterStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D9D9D9;
  border-radius: 2px;
  opacity: 1;
  text-align: left;
  font: normal normal normal 16px/24px;
  letter-spacing: 0px;
  color: #8C8C8C;
  width: 100%;
}


 /* styles.css */

.headerLineStyle {
  display: flex;
  flex-direction: row;
  margin-top: 2%;
  margin-bottom: 2%;
}

.headerSpanStyle {
  margin-right: 2%;
}

.marginLeft {
  padding-left: 4%;
  margin-top: 2%;
}

.marginRight {
  margin-right: 4%;
}

/* styles.css */

.marginTop10 {
  margin-top: 10%;
}

.marginRight5 {
  margin-right: 5%;
  margin-bottom: 3%;
}

.padding2 {
  padding-left: 2%;
  padding-right: 1%;
}

/* styles.css */

.paddingTop2 {
  padding-top: 2%;
}

.studyCntStyle {
  font: normal normal normal 16px/24px;
  letter-spacing: 0px;
  color: #8C8C8C;
  opacity: 1;
  margin-left: 1%;
  margin-bottom: 1%;
}

.cardFooterStyle {
  border: solid black;
  margin: 0;
}

  /* styles.css */

.cardFooterBtnStyle {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.cohertStyle {
  border: 1px solid #1890FF;
  font: normal normal normal 14px/22px;
  letter-spacing: 0px;
  color: #1890FF;
  margin-bottom: 2%;
}

.cardStyle {
  width: 400px; /* Adjust the width accordingly */
  margin-bottom: 0.5%;
  margin-left: 0%;
  padding-right: 0%;
  padding-left: 0%;
  margin-right: 2%;
}

.cardHeaderStyle {
  background: #FAFAFA 0% 0% no-repeat padding-box;
  border: 1px solid #D9D9D9;
  font: normal normal 600 14px/22px;
}

/* styles.css */

.cardBodyStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D9D9D9;
  padding-left: 0%;
  padding-right: 0%;
  height: 10%;
}

.flexWrapStyle {
  display: flex;
  flex-wrap: wrap;
}

.contentHeadingTextStyle {
  text-align: left;
  font: normal normal 600 14px/22px;
  letter-spacing: 0px;
  color: #262626;
}

/* styles.css */

.visibilityTextStyle {
  font: normal normal 600 14px/22px;
  letter-spacing: 0px;
  color: #262626;
}

.filterPgStyle {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  background: #000000CC;
  opacity: 1;
}

.filterPgInnerStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  opacity: 1;
  margin-left: 30%;
  margin-top: 10%;
  margin-right: 30%;
}

.filterBgStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  opacity: 1;
}

.filterHdOuterStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 6px;
  opacity: 1;
  padding: 2%;
}

.filterSampleHdStyle {
  padding-right: 5%;
  white-space: nowrap;
  text-align: left;
  font: normal normal normal 600 16px/24px;
  letter-spacing: 0px;
  color: #262626;
}
/* styles.css */

.filterCntStyle {
  padding-right: 60%;
  white-space: nowrap;
  text-align: left;
  font: normal normal normal 16px/24px;
  letter-spacing: 0px;
  color: #262626;
}

.filtersOutStyle {
  margin-left: 3%;
  margin-right: 3%;
  padding-bottom: 2%;
}

.filterNameOutStyle {
  display: flex;
  flex-direction: row;
  padding-top: 2%;
  width: 100%;
}

.filterNmInnStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D9D9D9;
  opacity: 1;
  padding-left: 0.5%;
  width: 28%;
  padding-top: 1%;
}

/* styles.css */

.filterNmTxtStyle {
  text-align: left;
  font: normal normal normal 16px/24px;
  letter-spacing: 0px;
  color: #595959;
  opacity: 1;
  background: #FAFAFA;
  white-space: nowrap;
  word-wrap: break-word;
}

.filterOperStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  opacity: 1;
  width: 18%;
}

.filterOperSelectStyle {
  width: 100%;
  border-radius: 0px;
}

.filterVal1Style {
  padding-bottom: 6%;
  height: 100%;
  border-radius: 0px;
}

.filterAmpOutStyle {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D9D9D9;
  opacity: 1;
  width: 10%;
  padding-top: 1%;
}
/* styles.css */

.filterAmpSty {
  padding-left: 30%;
  border-radius: 0px;
}

.filterNoneStyle {
  margin-top: 3%;
  margin-bottom: 15%;
  text-align: left;
  font: normal normal normal 14px/22px;
  letter-spacing: 0px;
  color: #595959;
}

.filterOverFlowStyle {
  height: 150px;
  overflow-y: auto;
}

.customFltrBtnStyle {
  border: 1px solid #1890FF;
}

.customFltrStyle {
  color: #1890FF;
}

.subGrpStyle {
  height: 300px;
  overflow-y: auto;
}

.subGrpNameSty {
  color: #262626;
  font: normal normal 600 16px/24px;
}

.subGrpTextSty {
  color: #262626;
}

.closeCohortStyle {
  border: none;
  left: 50%;
}

/* styles.css */

.cohortStyle {
  border-bottom: 1px solid #E9E9E9;
  border-top: 1px solid #E9E9E9;
  padding-top: 3%;
}

.cohortSuccessBg {
  background: #F6FFED 0% 0% no-repeat padding-box;
  border: 1px solid #B7EB8F;
  border-radius: 2px;
}

.cohortCheckStyle {
  color: #0dbd0d;
  padding-left: 0.5%;
  padding-right: 0.5%;
}

.cohortListSize {
  overflow-y: auto;
  height: 150px;
}

.cohortFooter {
  border-top: 1px solid #E9E9E9;
  padding-top: 5%;
}

.cohortNameStyle {
  font: normal normal 600 14px/22px;
  color: #595959;
}

.createCohortStyle {
  margin-top: 3%;
  left: 80%;
}

.custom-filter-close {
  background-color: #1677ff;
  margin-left: 2%;
  border-radius: 4px;
  padding-left: 1%;
  height: 25px;
  margin-top: 1%;
  margin-right: 1%;
  color: #FFFFFF;
  padding-top: 0.5%;
}`, "",{"version":3,"sources":["webpack://./src/styles/ViewStudyStyle.css"],"names":[],"mappings":"AAAA,eAAe;;AAEf;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,WAAW;AACb;;;CAGC,eAAe;;AAEhB;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;;AAEf;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,eAAe;;AAEf;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;EAEE,eAAe;;AAEjB;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY,EAAE,iCAAiC;EAC/C,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA,eAAe;;AAEf;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;AAChB;;AAEA,eAAe;;AAEf;EACE,iCAAiC;EACjC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,+CAA+C;EAC/C,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;AAChB;AACA,eAAe;;AAEf;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA,eAAe;;AAEf;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;EAC/C,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,eAAe;AACjB;AACA,eAAe;;AAEf;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAS;AACX;;AAEA,eAAe;;AAEf;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB","sourcesContent":["/* styles.css */\n\n.headerStyle {\n  width: 100%;\n  height: 30%;\n  background: #ffffff;\n  border: 1px solid #D9D9D9;\n  opacity: 1;\n}\n\n.searchStyle {\n  text-align: left;\n  font: normal normal normal 16px/24px;\n  letter-spacing: 0px;\n  color: #8C8C8C;\n  opacity: 1;\n  border-radius: 2px;\n  margin-left: 5%;\n}\n\n.filterStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 1px solid #D9D9D9;\n  border-radius: 2px;\n  opacity: 1;\n  text-align: left;\n  font: normal normal normal 16px/24px;\n  letter-spacing: 0px;\n  color: #8C8C8C;\n  width: 100%;\n}\n\n\n /* styles.css */\n\n.headerLineStyle {\n  display: flex;\n  flex-direction: row;\n  margin-top: 2%;\n  margin-bottom: 2%;\n}\n\n.headerSpanStyle {\n  margin-right: 2%;\n}\n\n.marginLeft {\n  padding-left: 4%;\n  margin-top: 2%;\n}\n\n.marginRight {\n  margin-right: 4%;\n}\n\n/* styles.css */\n\n.marginTop10 {\n  margin-top: 10%;\n}\n\n.marginRight5 {\n  margin-right: 5%;\n  margin-bottom: 3%;\n}\n\n.padding2 {\n  padding-left: 2%;\n  padding-right: 1%;\n}\n\n/* styles.css */\n\n.paddingTop2 {\n  padding-top: 2%;\n}\n\n.studyCntStyle {\n  font: normal normal normal 16px/24px;\n  letter-spacing: 0px;\n  color: #8C8C8C;\n  opacity: 1;\n  margin-left: 1%;\n  margin-bottom: 1%;\n}\n\n.cardFooterStyle {\n  border: solid black;\n  margin: 0;\n}\n\n  /* styles.css */\n\n.cardFooterBtnStyle {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.cohertStyle {\n  border: 1px solid #1890FF;\n  font: normal normal normal 14px/22px;\n  letter-spacing: 0px;\n  color: #1890FF;\n  margin-bottom: 2%;\n}\n\n.cardStyle {\n  width: 400px; /* Adjust the width accordingly */\n  margin-bottom: 0.5%;\n  margin-left: 0%;\n  padding-right: 0%;\n  padding-left: 0%;\n  margin-right: 2%;\n}\n\n.cardHeaderStyle {\n  background: #FAFAFA 0% 0% no-repeat padding-box;\n  border: 1px solid #D9D9D9;\n  font: normal normal 600 14px/22px;\n}\n\n/* styles.css */\n\n.cardBodyStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 1px solid #D9D9D9;\n  padding-left: 0%;\n  padding-right: 0%;\n  height: 10%;\n}\n\n.flexWrapStyle {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.contentHeadingTextStyle {\n  text-align: left;\n  font: normal normal 600 14px/22px;\n  letter-spacing: 0px;\n  color: #262626;\n}\n\n/* styles.css */\n\n.visibilityTextStyle {\n  font: normal normal 600 14px/22px;\n  letter-spacing: 0px;\n  color: #262626;\n}\n\n.filterPgStyle {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: auto;\n  background: #000000CC;\n  opacity: 1;\n}\n\n.filterPgInnerStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  opacity: 1;\n  margin-left: 30%;\n  margin-top: 10%;\n  margin-right: 30%;\n}\n\n.filterBgStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  opacity: 1;\n}\n\n.filterHdOuterStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border-radius: 6px;\n  opacity: 1;\n  padding: 2%;\n}\n\n.filterSampleHdStyle {\n  padding-right: 5%;\n  white-space: nowrap;\n  text-align: left;\n  font: normal normal normal 600 16px/24px;\n  letter-spacing: 0px;\n  color: #262626;\n}\n/* styles.css */\n\n.filterCntStyle {\n  padding-right: 60%;\n  white-space: nowrap;\n  text-align: left;\n  font: normal normal normal 16px/24px;\n  letter-spacing: 0px;\n  color: #262626;\n}\n\n.filtersOutStyle {\n  margin-left: 3%;\n  margin-right: 3%;\n  padding-bottom: 2%;\n}\n\n.filterNameOutStyle {\n  display: flex;\n  flex-direction: row;\n  padding-top: 2%;\n  width: 100%;\n}\n\n.filterNmInnStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 1px solid #D9D9D9;\n  opacity: 1;\n  padding-left: 0.5%;\n  width: 28%;\n  padding-top: 1%;\n}\n\n/* styles.css */\n\n.filterNmTxtStyle {\n  text-align: left;\n  font: normal normal normal 16px/24px;\n  letter-spacing: 0px;\n  color: #595959;\n  opacity: 1;\n  background: #FAFAFA;\n  white-space: nowrap;\n  word-wrap: break-word;\n}\n\n.filterOperStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  opacity: 1;\n  width: 18%;\n}\n\n.filterOperSelectStyle {\n  width: 100%;\n  border-radius: 0px;\n}\n\n.filterVal1Style {\n  padding-bottom: 6%;\n  height: 100%;\n  border-radius: 0px;\n}\n\n.filterAmpOutStyle {\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 1px solid #D9D9D9;\n  opacity: 1;\n  width: 10%;\n  padding-top: 1%;\n}\n/* styles.css */\n\n.filterAmpSty {\n  padding-left: 30%;\n  border-radius: 0px;\n}\n\n.filterNoneStyle {\n  margin-top: 3%;\n  margin-bottom: 15%;\n  text-align: left;\n  font: normal normal normal 14px/22px;\n  letter-spacing: 0px;\n  color: #595959;\n}\n\n.filterOverFlowStyle {\n  height: 150px;\n  overflow-y: auto;\n}\n\n.customFltrBtnStyle {\n  border: 1px solid #1890FF;\n}\n\n.customFltrStyle {\n  color: #1890FF;\n}\n\n.subGrpStyle {\n  height: 300px;\n  overflow-y: auto;\n}\n\n.subGrpNameSty {\n  color: #262626;\n  font: normal normal 600 16px/24px;\n}\n\n.subGrpTextSty {\n  color: #262626;\n}\n\n.closeCohortStyle {\n  border: none;\n  left: 50%;\n}\n\n/* styles.css */\n\n.cohortStyle {\n  border-bottom: 1px solid #E9E9E9;\n  border-top: 1px solid #E9E9E9;\n  padding-top: 3%;\n}\n\n.cohortSuccessBg {\n  background: #F6FFED 0% 0% no-repeat padding-box;\n  border: 1px solid #B7EB8F;\n  border-radius: 2px;\n}\n\n.cohortCheckStyle {\n  color: #0dbd0d;\n  padding-left: 0.5%;\n  padding-right: 0.5%;\n}\n\n.cohortListSize {\n  overflow-y: auto;\n  height: 150px;\n}\n\n.cohortFooter {\n  border-top: 1px solid #E9E9E9;\n  padding-top: 5%;\n}\n\n.cohortNameStyle {\n  font: normal normal 600 14px/22px;\n  color: #595959;\n}\n\n.createCohortStyle {\n  margin-top: 3%;\n  left: 80%;\n}\n\n.custom-filter-close {\n  background-color: #1677ff;\n  margin-left: 2%;\n  border-radius: 4px;\n  padding-left: 1%;\n  height: 25px;\n  margin-top: 1%;\n  margin-right: 1%;\n  color: #FFFFFF;\n  padding-top: 0.5%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
